import React from 'react'
import ApproveProjects from '../../../components/ApproveProjects'

const ApprovedProjectsIgr = ({ t, approvedprojects, formatMillions }) => {
    return (
        <div className="approve-projects">
            <div>
                <h3 className="chart-title mb-2">{t('one_pager_report.approved_proyects')}</h3>
                <div className="c-approve-projects">
                    <ApproveProjects
                        projects={approvedprojects?.aprprovedProjectCount}
                        title={t('one_pager_report.number_approved_projects')}
                        value={formatMillions(approvedprojects?.aprprovedProjectAmount)}
                    />
                    <ApproveProjects
                        projects={approvedprojects?.preparationProjectCount}
                        title={`${t('one_pager_report.projects_in_preparation')} (Pipeline A)`}
                        value={formatMillions(approvedprojects?.preparationProjectAmount)}
                    />
                </div>
            </div>
        </div>
    )
}

export default ApprovedProjectsIgr